import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CKEditor4 } from "ckeditor4-angular/ckeditor";
import * as moment from 'moment';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-create-quiz-task',
  templateUrl: './create-quiz-task.component.html',
  styleUrls: ['./create-quiz-task.component.scss']
})
export class CreateQuizTaskComponent implements OnInit {
  engagementTypes: any = [];
  roleTypes:any = [];

  editorConfig = {
    toolbarGroups: [
      { name: "clipboard", groups: ["clipboard", "undo"] },
      { name: "editing", groups: ["find", "selection", "spellchecker"] },
      { name: "links" },
      { name: "insert" },
      { name: "document", groups: ["mode", "document", "doctools"] },
      { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
      { name: "paragraph", groups: ["list", "indent", "blocks", "align"] },
      { name: "styles" },
      { name: "colors" },
    ],
    skin: "kama",
    resize_enabled: false,
    removePlugins: "elementspath,save,magicline",
    extraPlugins: "divarea,smiley,justify,indentblock,colordialog",
    colorButton_foreStyle: {
      element: "font",
      attributes: { color: "#(color)" },
    },
    height: 188,
    versionCheck : false,
    removeDialogTabs: "image:advanced;link:advanced",
    removeButtons: "Subscript,Superscript,Anchor,Source,Table",
    format_tags: "p;h1;h2;h3;pre;div",
  };

  @Input() engagementId = "";

  @Output() engagementCreated: EventEmitter<boolean> = new EventEmitter;
  @Output() getEngagementId: EventEmitter<number> = new EventEmitter;
  @Output() getEngagementTypeId: EventEmitter<number> = new EventEmitter;
  @Output() whitelist_obj: EventEmitter<object> = new EventEmitter;

  audit_templete: any = "";
  formGroup: FormGroup;
  localData: any;
  submitted: boolean = false;
  minDate: any;
  isUserwhitelisted : boolean = false;

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService
  ) {
    this.localData = JSON.parse(localStorage.getItem('engagementDetail'))
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0];
  }

  ngOnInit() {
    this.form()
    this.getEngagementTypes();
    this.getRoleTypes();
    if(this.localData.is_edit == true){
      this.getEnagagementData()
      this.whitelist_obj.emit({wts_type : this.localData.whitelist_type ,zn_type : this.localData.zone_type})
    }
  }

  form(data?){
    this.formGroup = this.fb.group({
      'engagement_type': new FormControl(data ? data.engagement_type_id : "", [Validators.required]),
      'engagement_name': new FormControl(data ? data.engagement_title : "", [Validators.required]),
      'start_date': new FormControl(data ? data.start_date : "", [Validators.required]),
      'end_date': new FormControl(data ? data.end_date : "", [Validators.required]),
      'reward_type': new FormControl(data ? data.quiz_points_criteria : "", [Validators.required]),
      whitelist_type : new FormControl(data?data.whitelist_type:"",[Validators.required]),
      zone_type : new FormControl(data?data.zone_type:""),
      role_type : new FormControl({value : data?data.role_type:"" , disabled: this.isUserwhitelisted ? true : false},[]),
      'questionsSet': this.fb.array([])
    });
    if(data){
      if (data.questions) {
        data.questions.forEach(question => {
          this.addQuestions(question);
        });
      }
    }else{
      this.addQuestions()
    }
  }

  get formData (){
    return this.formGroup.getRawValue()
  } 

  get f() {
    return this.formGroup.controls;
  }

  whitelistTypeChange(e){
    console.log(e);
    if(e.target.value == '2'){
      this.formGroup.get('zone_type').setValidators([Validators.required])
    }
  }

  getRoleTypes(){
    this.apiService.get(this.apiConfig.configGetRoles).subscribe((res)=>{
      this.roleTypes = res['data'].filter(item => item.id == 5)
      console.log(this.roleTypes);
    })
  }

  getEngagementTypes() {
    this.apiService.get(this.apiConfig.engagementTypes + `?engagement_page=2`).subscribe((res: any) => {
      console.log(res)
      this.engagementTypes = res.data.engagementtypes;
    })
  }


  getEnagagementData() {
    this.apiService.get(this.apiConfig.viewEngagementDetail + `?engagement_page=2&engagement_type_id=${this.localData.engagement_type_id}&portfolio_id=${this.localData.protfolio_id}&task_id=${this.localData.task_id}`).subscribe((res: any) => {
      this.isUserwhitelisted = res.data.engagement.is_whitelisted

      if(this.isUserwhitelisted){
        this.formGroup.get('whitelist_type').disable()
        this.formGroup.get('role_type').disable()
      }
      setTimeout(() => {
        this.form(res.data.engagement)
      }, 100);
    })
  }

  addQuestions(question?: any) {
    let fg = this.fb.group({
      'question': new FormControl({value : question ? question.question : '' , disabled: this.isUserwhitelisted ? true : false} , []),
      'answer': new FormControl({value : question ? question.answer : '' , disabled: this.isUserwhitelisted ? true : false} , [Validators.required]),
      'point':  new FormControl({value : question ? question.points : '' , disabled: this.isUserwhitelisted ? true : false} , [Validators.required,Validators.min(1)]),
      'options': this.fb.array([]),
    });
    (<FormArray>this.formGroup.get('questionsSet')).push(fg);
    let questionIndex = (<FormArray>this.formGroup.get('questionsSet')).length - 1;
    if (!question) {
      this.addOptions(questionIndex);
    }
    else {
      question.option.forEach(option => {
        this.addOptions(questionIndex, option);
      });
    }
  }

  deleteQuestions(index: number) {
    (<FormArray>this.formGroup.get('questionsSet')).removeAt(index);
  }

  addOptions(questionsIndex: number, data?: any) {
    if ((<FormArray>(<FormGroup>(<FormArray>this.formGroup.controls['questionsSet']).controls[questionsIndex]).controls['options']).length == 4) {
      return
    }
    console.log('questionsIndex', questionsIndex, '-------', 'data', data);
    let fg = this.fb.group({
      'option': new FormControl({ value :data ? data.option : '' , disabled: this.isUserwhitelisted ? true : false}, []),
    });
    (<FormArray>(<FormGroup>(<FormArray>this.formGroup.controls['questionsSet'])
      .controls[questionsIndex]).controls['options']).push(fg);

  }

  deleteOptions(questionsIndex: number, index: number) {
    console.log('questionsIndex', questionsIndex, '-------', 'index', index);
    (<FormArray>(<FormGroup>(<FormArray>this.formGroup.controls['questionsSet'])
      .controls[questionsIndex]).controls['options']).removeAt(index);
  }


  onSubmit(formGroup) {
    console.log(this.formGroup)
    this.submitted = true;
    let value = formGroup.getRawValue()
    console.log(value);

    if (this.formGroup.invalid) {
      return this.toast.Warning('Select Required Feilds or Give valid inputs');
    }

    let payload = {
      portfolio_id: 1,
      engagement_id: value.engagement_type,
      engagement_title: value.engagement_name,
      start_date: moment(value.start_date).format("YYYY-MM-DD"),
      end_date: moment(value.end_date).format("YYYY-MM-DD"),
      quiz_points_criteria: value.reward_type,
      questions: value.questionsSet,
      isEdit: this.localData.is_edit ? 1 : 0,
      task_id: this.engagementId,
      course_type: 4,
      audit_instructions: "",
      whitelist_type : this.f.whitelist_type.value,
      zone_type : value.zone_type,
      role_type : value.role_type
    }

    console.log(payload)
    this.apiService.post(this.apiConfig.createEngagementQuiz, payload).subscribe((res: any) => {
      console.log(res)
      this.toast.Success("Engagement created Successfully")
      
      this.localData.task_id = res.body.data.task_id,
      this.localData.sub_tasks_id = res.body.data.sub_tasks_id,
      this.localData.has_subtask = res.body.data.has_subtask,
      this.localData.engagement_type_id = res.body.data.engagement_type_id,
      this.localData.engagement_type = res.body.data.engagement_type,
      this.localData.protfolio_id = value.portfolio,
      this.localData.whitelist_type  = value.whitelist_type,
      this.localData.zone_type  = value.zone_type,
      this.localData.role_type  = value.role_type,
      this.localData.is_edit =true

      localStorage.setItem("engagementDetail" , JSON.stringify(this.localData))
      this.engagementCreated.emit(true)
      this.getEngagementId.emit(res.body.data.task_id);
      this.getEngagementTypeId.emit(res.body.data.engagement_type_id)
      this.whitelist_obj.emit({wts_type : value.whitelist_type ,zn_type : value.zone_type})
    })
  }

  ngOnDestroy(): void {
  }

}
